import { produce } from 'immer';
/**
 * Avoids having to rewrite the repetitive:
 * ```ts
 * (old) => produce(old, (draft) => callback(draft)),
 * ```
 * @param updater a function that takes a draft and modifies it
 */
export const produceCallback = (updater) => (old) => produce(old, (draft) => updater(draft));
//# sourceMappingURL=produce-callback.js.map